import {
  BUILD_COMMITMENT,
  COMMITMENT_CHANGED,
  UPDATE_COMMITMENTS_START,
  UPDATE_COMMITMENTS_SUCCESS,
  UPDATE_COMMITMENTS_FAILURE,
} from './types';

export const buildCommitment = (payload) => ({
  type: BUILD_COMMITMENT,
  payload: payload
})

export const commitmentChanged = (payload) => ({
  type: COMMITMENT_CHANGED,
  payload: payload,
})

export const updateCommitmentsStart = (payload) => ({
  type: UPDATE_COMMITMENTS_START,
  payload: payload,
})

export const updateCommitmentsSuccess = (payload) => ({
  type: UPDATE_COMMITMENTS_SUCCESS,
  payload: payload,
})

export const updateCommitmentsFailure = (payload) => ({
  type: UPDATE_COMMITMENTS_FAILURE,
  payload: payload,
})
